import OrdersDesktop from './OrdersDesktop';

export default OrdersDesktop;
